export default {
  props: ['skills']
};